<div class="encription-setting">
    <mat-slide-toggle name="encryption"
        data-testid="connection-master-encryption-toggle"
        angulartics2On="click"
        angularticsAction="Connection creds: client-side encryption is switched"
        [angularticsProperties]="{'enable': isMasterKeyTurnedOn}"
        [disabled]="disabled"
        [(ngModel)]="isMasterKeyTurnedOn"
        (ngModelChange)="generatePassword($event)">
        Use client-side encryption
    </mat-slide-toggle>
    <div *ngIf="isMasterKeyTurnedOn && masterKey" class="encription-password">
        <div class="encription-password__field">
            <mat-form-field appearance="outline" style="width:100%">
                <mat-label>Master password</mat-label>
                <input matInput data-testid="connection-master-password-input"
                    name="masterPassword" #masterPassword="ngModel"
                    readonly
                    [(ngModel)]="masterKey">
            </mat-form-field>
            <button mat-icon-button type="button" data-testid="connection-master-password-copy-button"
                class="encription-password__copy-button"
                [cdkCopyToClipboard]="masterKey"
                (cdkCopyToClipboardCopied)="showCopyNotification('Master password was copied to clipboard.')">
                <mat-icon>content_copy</mat-icon>
            </button>
        </div>

        <div class="docs-notification">
            <div>
                <p class="docs-notification__warning">
                    Rocketadmin will not store your master password.
                    <br/>
                    To retain access, store it in a safe place.
                    <br/>
                    Share it only with users you want to have access to this connection.
                </p>
                <a href="https://docs.rocketadmin.com/Reference/MasterPassword"
                    target="_blank" class="docs-link">
                    Open docs
                </a>
            </div>
        </div>
    </div>
</div>